import React, { useState, useEffect, useContext } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { UserContext } from '../../context/User';
import { useLocation, useHistory } from "react-router-dom";
import { businessGet } from '../../api';
import Loading from '../Loading';
import { somethingWentWrongNotice } from '../UI/Notifications';
import SinglePageItemText from '../SinglePageItemTypes/SinglePageItemText';
import SinglePageItemArray from '../SinglePageItemTypes/SinglePageItemArray';
import SinglePageItemBool from '../SinglePageItemTypes/SinglePageItemBool';

const BusinessSingle = () => {
  const useQuery = () => new URLSearchParams(useLocation().search);
  const query = useQuery();
  const id = query.get("id");
  const [businessData, setBusinessData] = useState([]);
  const [loading, setLoading] = useState(false);
  const { setUser, setIsLoggedIn } = useContext(UserContext);
  const history = useHistory();

  const logout = () => {
    setIsLoggedIn(false);
    setUser({});
    history.push('/');
  }

  const handleDefaultStatusCodes = (status_code) => {
    if (status_code === 440 || status_code === 401) {
      logout()
    } else {
      somethingWentWrongNotice("Search");
    }

    setLoading(false);
  }

  useEffect(() => {
    if (id) {
      setLoading(true);
      businessGet({id})
        .then(response => {
          setBusinessData(response.data);
          setLoading(false);
        })
        .catch(error => {
          handleDefaultStatusCodes(error.response.status);
          setLoading(false);
        })
    }
  }, [])

  return (
    <section className="section-spaces">
       <Container>
        <Row>
          <Col>
            <div className="single-page-wrap">
              <h3>{businessData.name}</h3>
              <Link
                to={`/specific-message?id=${businessData.user_id}`}
                className="btnSizes filledBtn link my-2"
              >
                Contact
              </Link>
              <SinglePageItemText 
                title="Point of Contact (POC)"
                value={businessData.contact}
              />
              <SinglePageItemText 
                title="Address"
                value={businessData.address1}
              />
              <SinglePageItemText 
                title="City"
                value={businessData.city}
              />
              <SinglePageItemText 
                title="State"
                value={businessData.state}
              />
              <SinglePageItemText 
                title="ZIP Code"
                value={businessData.zip}
              />
              <SinglePageItemText 
                title="Phone Number"
                value={businessData.phone}
              />
              <SinglePageItemText 
                title="Fax"
                value={businessData.fax}
              />
              <SinglePageItemText 
                title="Email"
                value={businessData.email}
              />
              <SinglePageItemArray 
                type="pm"
                title="Business Identification"
                value={businessData.set_aside}
              />
              <SinglePageItemArray 
                type="pm"
                title="Business Type"
                value={businessData.type}
              />
              <SinglePageItemText 
                title="Business Description"
                value={businessData.description}
              />
              <SinglePageItemBool 
                title="Sells 3rd-Party Certified Environmentally-Friendly Products"
                value={businessData.env_products}
              />
              <SinglePageItemText 
                title="GSA Contract Number"
                value={businessData.contract_num}
              />
              <SinglePageItemText 
                title="DUNS Number"
                value={businessData.duns_number}
              />
              <SinglePageItemText 
                title="UEI"
                value={businessData.uei}
              />
              <SinglePageItemText 
                title="Cage Code"
                value={businessData.cage_code}
              />
              <SinglePageItemText 
                title="Tax ID Number"
                value={businessData.tax_number}
              />
              <SinglePageItemBool 
                title="SAM Registered"
                value={businessData.env_products}
              />
              <SinglePageItemText 
                title="Ship to Address"
                value="N/A"
              />
              <SinglePageItemArray 
                title="NAICS Code"
                type="pm"
                value={businessData.naics}
              />
              <SinglePageItemBool 
                title="Accept Credit Cards"
                value={businessData.credit}
              />
              <SinglePageItemArray 
                title="Payment Method"
                type="pm"
                value={businessData.payment_method}
              />
              <SinglePageItemBool 
                title="Discount Terms"
                value={businessData.discounts}
              />
              <SinglePageItemBool 
                title="Shipping Terms"
                value={businessData.shipping_terms}
              />
            </div>
          </Col>
        </Row>
        {loading && <Loading />}
      </Container>    
    </section>
  )
}

export default BusinessSingle;